import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const stats = [{
  value: '200',
  label: 'Players'
}, {
  value: '+$10M',
  label: 'in cash and prizes'
}, {
  value: '$5M',
  label: 'winning prize'
}];
export function UltimateCompetitionSection() {
  return <section className="relative w-full py-24 bg-[#0f0f1a] overflow-hidden" data-id="element-163">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-[#0f0f1a] to-[#0f0f1a] pointer-events-none" data-id="element-164" />

      <div className="relative z-10 max-w-7xl mx-auto px-6" data-id="element-165">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-166">
          <h2 className="font-oswald text-5xl md:text-7xl lg:text-8xl font-bold text-white uppercase tracking-wider mb-4" data-id="element-167">
            The Ultimate <span className="text-[#ffd700]" data-id="element-168">Competition</span>
          </h2>
        </motion.div>

        {/* Stats Row */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16 lg:gap-24 mb-16" data-id="element-169">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3 + index * 0.1
        }} className="text-center" data-id="element-170">
              <div className="font-oswald text-6xl md:text-7xl lg:text-8xl font-bold text-[#ffd700] mb-2" data-id="element-171">
                {stat.value}
              </div>
              <div className="text-gray-400 text-lg md:text-xl uppercase tracking-widest font-medium" data-id="element-172">
                {stat.label}
              </div>
            </motion.div>)}
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="flex justify-center mb-20" data-id="element-173">
          <motion.a href="https://form.typeform.com/to/VFERkcyN" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} className="group relative inline-flex items-center justify-center px-12 py-6 font-bold text-black transition-all duration-300 bg-[#ffd700] font-oswald text-2xl md:text-3xl uppercase tracking-widest rounded-lg shadow-xl hover:shadow-2xl hover:shadow-[#ffd700]/30 hover:bg-white" data-id="element-174">
            <span data-id="element-175">Compete on Season 3</span>
            <ArrowRight className="ml-4 w-8 h-8 group-hover:translate-x-2 transition-transform" data-id="element-176" />
          </motion.a>
        </motion.div>

        {/* Description Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="max-w-4xl mx-auto text-center" data-id="element-177">
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-8" data-id="element-178">
            After a record-shattering first season,{' '}
            <strong className="text-white" data-id="element-179">Beast Games is back!</strong> With a
            life-changing{' '}
            <span className="font-bold text-[#ffd700]" data-id="element-180">$5,000,000</span> prize
            on the line, MrBeast brings together{' '}
            <strong className="text-white" data-id="element-181">100 of the strongest</strong> and{' '}
            <strong className="text-white" data-id="element-182">100 of the smartest</strong> players
            on the planet.
          </p>
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-8" data-id="element-183">
            Will it be superhuman strength or super genius that takes home the
            grand prize? Each game will test the limits of human strength,
            intelligence, and strategy.
          </p>
          <p className="text-3xl md:text-4xl font-oswald font-bold text-white" data-id="element-184">
            What WOULDN'T you do for{' '}
            <span className="text-[#ffd700]" data-id="element-185">$5,000,000</span>?
          </p>
        </motion.div>
      </div>
    </section>;
}